import React from 'react';

import { Page } from '@occc-app/design-system';

import { ProgramManagement } from './ProgramManagement';

const PAGE_TITLE = 'Program Management';

export const ProgramManagementPage = () => {
  return (
    <Page
      browserTabTitle={PAGE_TITLE}
      pageHeaderProps={{
        title: PAGE_TITLE,
        subtitle:
          'Program Management provides a single place to configure your Product Catalog, setup program wide Offers, and more!',
      }}
    >
      <ProgramManagement />
    </Page>
  );
};
